<!-- CTA Banner -->
<section class="cta-banner">
  <div class="cta-inner">
    <h2>The Only Tool You Need to Schedule Your Day</h2>
    <p>Always keep updated with this simple tool on the go, whenever and wherever you need.</p>
    <button class="cta-btn" (click)="getStarted()">Get Started Free</button>
  </div>
</section>

<!-- Pricing -->
<section class="pricing-section">
  <h2 class="pricing-heading">Pricing</h2>
  <p class="pricing-sub">Choose the plan that fits your team. Upgrade or downgrade anytime.</p>

  <div class="plan-grid">

    <!-- Free -->
    <div class="plan-card" (click)="goToPlan('free')">
      <div class="plan-name">Free</div>
      <div class="plan-price">$0 <span class="plan-period">/ month</span></div>
      <p class="plan-desc">Perfect for individuals starting out with basic needs.</p>
      <ul class="plan-features">
        <li>1 team member</li>
        <li>Basic task management</li>
        <li>Limited support</li>
      </ul>
      <button class="plan-btn plan-btn--free" (click)="$event.stopPropagation(); getStarted()">Get Started</button>
      <div class="plan-detail-link" (click)="$event.stopPropagation(); goToPlan('free')">
        See full details →
      </div>
    </div>

    <!-- Pro -->
    <div class="plan-card plan-card--featured" (click)="goToPlan('pro')">
      <div class="plan-badge">Most Popular</div>
      <div class="plan-name">Pro</div>
      <div class="plan-price">$29 <span class="plan-period">/ month</span></div>
      <p class="plan-desc">Ideal for small teams looking to collaborate efficiently.</p>
      <ul class="plan-features">
        <li>5 team members</li>
        <li>Advanced task management</li>
        <li>Email support</li>
      </ul>
      <button class="plan-btn plan-btn--pro" (click)="$event.stopPropagation(); goToPlan('pro')">Choose Plan</button>
      <div class="plan-detail-link" (click)="$event.stopPropagation(); goToPlan('pro')">
        See full details →
      </div>
    </div>

    <!-- Enterprise -->
    <div class="plan-card" (click)="goToPlan('enterprise')">
      <div class="plan-name">Enterprise</div>
      <div class="plan-price">$99 <span class="plan-period">/ month</span></div>
      <p class="plan-desc">Designed for large businesses with extensive needs.</p>
      <ul class="plan-features">
        <li>Unlimited team members</li>
        <li>Full project management suite</li>
        <li>Priority support</li>
      </ul>
      <button class="plan-btn plan-btn--enterprise" (click)="$event.stopPropagation(); goToPlan('enterprise')">Choose Plan</button>
      <div class="plan-detail-link" (click)="$event.stopPropagation(); goToPlan('enterprise')">
        See full details →
      </div>
    </div>

  </div>
</section>

<!-- Stats strip -->
<section class="stats-strip">
  <div class="stat">
    <span class="stat-emoji">😊</span>
    <strong>100%</strong>
    <span>Satisfaction</span>
  </div>
  <div class="stat">
    <span class="stat-emoji">👥</span>
    <strong>4.5K</strong>
    <span>Customers</span>
  </div>
  <div class="stat">
    <span class="stat-emoji">🏗️</span>
    <strong>12K+</strong>
    <span>Projects Managed</span>
  </div>
  <div class="stat">
    <span class="stat-emoji">⭐</span>
    <strong>4.8</strong>
    <span>Average Rating</span>
  </div>
</section>
